import React, { useState, useEffect } from "react";
import * as yup from "yup";
import { Formik } from "formik";
import { DialogActions } from "@material-ui/core";
import { Table } from "react-bootstrap";
import { CustomTextField } from "../../partials/content/Forms";
import { onPreventEnterSubmitting } from "../../utils/utils";
import { activateCompanyProfileLicense } from "../../services/setup/company-profile/companyProfileService";
import { toAbsoluteUrl } from "../../../_metronic/utils/utils";
import { Typography } from "@material-ui/core";
import { Image } from "primereact/image";
import Swal from "sweetalert2";
const ActivatePlatform = ({
  activeStep,
  handleBack,
  handleSkip,
  handleNext,
  companyProfile,
  handleReloadCompanyProfile,
}) => {
  const [licenseKeyData, setLicenseKeyData] = useState({
    licenseKey: "",
  });

  useEffect(() => {}, []);

  const licenseKeyFormSchema = yup.object().shape({
    licenseKey: yup
      .string()
      .required("License Key is required for activation")
      .test("len", "License Key must be exactly 16 characters", (val) => {
        if (val) return val.toString().length === 16;
      }),
  });
  return (
    <React.Fragment>
      {companyProfile.globalCustomerID === 0 ||
      companyProfile.licenseKey === "" ? (
        <React.Fragment>
          <Formik
            initialValues={licenseKeyData}
            validationSchema={licenseKeyFormSchema}
            enableReinitialize={true}
            onSubmit={async (values, { setStatus, setSubmitting }) => {
              Swal.mixin({
                customClass: {
                  confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
                },
                buttonsStyling: false,
              })
                .fire({
                  title: "Are you sure want to activate this License Key ?",
                  text: "Please note that you are responsible for this action",
                  icon: "question",
                  showCloseButton: true,
                  showCancelButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, activate it`,
                  cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
                  reverseButtons: true,
                })
                .then((result) => {
                  if (result.isConfirmed) {
                    activateCompanyProfileLicense(values).then((response) => {
                      Swal.mixin({
                        customClass: {
                          confirmButton:
                            "btn btn-success btn-md btn-pill btn-bold",
                        },
                        buttonsStyling: false,
                      }).fire({
                        title: "Activated",
                        html: response.data.message,
                        icon: "success",
                        showCloseButton: true,
                        confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                      });
                      handleReloadCompanyProfile();
                    });
                  } else if (result.dismiss === Swal.DismissReason.cancel) {
                    Swal.mixin({
                      customClass: {
                        confirmButton:
                          "btn btn-success btn-md btn-pill btn-bold",
                      },
                      buttonsStyling: false,
                    }).fire({
                      title: "Cancelled",
                      text: "No change has been made",
                      icon: "info",
                      showCloseButton: true,
                      confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                    });
                  }
                });
            }}
          >
            {({
              values,
              status,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              setFieldValue,
              isSubmitting,
            }) => (
              <form
                noValidate={true}
                autoComplete="off"
                className="kt-form"
                onSubmit={handleSubmit}
                onKeyDown={onPreventEnterSubmitting}
              >
                <div className="horizontal-step-content">
                  <div className="row justify-content-center">
                    <div className="col-sm-4 col-md-4 col-lg-4">
                      <div className="column">
                        <div className="col-sm-12 col-md-12 col-lg-12">
                          <CustomTextField
                            label="License Key"
                            inputType="text"
                            propertyName="licenseKey"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            values={values}
                            touched={touched}
                            errors={errors}
                            size="small"
                            upperCase="uppercase"
                          />
                          <Typography align="center">
                            <button
                              type="submit"
                              className="btn btn-success btn-md btn-pill btn-bold my-2"
                              disabled={isSubmitting}
                            >
                              <i className="fas fa-power-off"></i>
                              Activate
                            </button>
                          </Typography>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <DialogActions>
                  <button
                    type="button"
                    className="btn btn-primary btn-md btn-pill btn-bold"
                    onClick={handleNext}
                    disabled={companyProfile.licenseKey === ""}
                  >
                    <i className="fas fa-arrow-circle-right"></i>
                    Next
                  </button>
                </DialogActions>
              </form>
            )}
          </Formik>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <div className="horizontal-step-content">
            <div className="row justify-content-center">
              <div className="col-sm-6 col-md-6 col-lg-6">
                <div className="column">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <Typography align="center">
                      Hi, our valuable Customer.
                    </Typography>
                    <Typography align="center">
                      Thanks for being our{" "}
                      {companyProfile.globalCustomerLevelName}. A few steps
                      ahead and Invifo platform will be yours.
                    </Typography>
                    <Typography align="center" className="my-5">
                      {companyProfile.globalCustomerLevel === 1 ? (
                        <Image
                          src={toAbsoluteUrl(
                            "/media/logos/invifo-silver-customer-lg.png"
                          )}
                          imageStyle={{
                            maxWidth: "200px",
                          }}
                          alt="Global Customer Level"
                          fluid
                        />
                      ) : companyProfile.globalCustomerLevel === 2 ? (
                        <Image
                          src={toAbsoluteUrl(
                            "/media/logos/invifo-gold-customer-lg.png"
                          )}
                          imageStyle={{
                            maxWidth: "200px",
                          }}
                          alt="Global Customer Level"
                          fluid
                        />
                      ) : companyProfile.globalCustomerLevel === 3 ? (
                        <Image
                          src={toAbsoluteUrl(
                            "/media/logos/invifo-platinum-customer-lg.png"
                          )}
                          imageStyle={{
                            maxWidth: "200px",
                          }}
                          alt="Global Customer Level"
                          fluid
                        />
                      ) : companyProfile.globalCustomerLevel === 4 ? (
                        <Image
                          src={toAbsoluteUrl(
                            "/media/logos/invifo-custom-customer-lg.png"
                          )}
                          imageStyle={{
                            maxWidth: "200px",
                          }}
                          alt="Global Customer Level"
                          fluid
                        />
                      ) : null}
                    </Typography>
                    <Table borderless size="sm">
                      <tbody>
                        <tr className="border-bottom-0">
                          <td className="w-50 table-header-left pl-0 pr-3 py-1 text-right kt-font-bolder">
                            License Key
                          </td>
                          <td className="w-50pl-0 pl-3 py-1">
                            {companyProfile.licenseKey}
                          </td>
                        </tr>
                        <tr className="border-bottom-0">
                          <td className="w-50 table-header-left pl-0 pr-3 py-1 text-right kt-font-bolder">
                            Global Customer ID
                          </td>
                          <td className="w-50pl-0 pl-3 py-1">
                            {companyProfile.globalCustomerID}
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <DialogActions>
            <button
              type="button"
              className="btn btn-primary btn-md btn-pill btn-bold"
              onClick={handleNext}
              disabled={companyProfile.licenseKey === ""}
            >
              <i className="fas fa-arrow-circle-right"></i>
              Next
            </button>
          </DialogActions>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default ActivatePlatform;
